<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>

    <div class="relative">
      <input 
        ref="input" 
        :id="id" 
        v-bind="{ ...$attrs, class: null }" 
        class="form-input" 
        :class="{ error: error }" 
        :type="type"
        :value="datetimeValue"
        v-model="datetimeValue"
        v-mask="'##/##/#### ##:##'"
        :disabled="disabled" />

      <button 
        type="button" 
        class="absolute right-0" 
        @click.prevent="$e => this.$refs.datepicker.openMenu()">
          <font-awesome-icon icon="fa-regular fa-calendar" />
      </button>
    </div>
    
    <Datepicker 
      ref="datepicker"
      v-model="datetimeValue"
      modelType="dd/MM/yyyy HH:mm"
      weekStart="0" 
      autoApply 
      :closeOnAutoApply="false" 
      :class="{ error: error }" 
      locale="pt-BR"
      :clearable="false"
      :disabled="disabled">
        <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
        </template>
    </Datepicker>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>

import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { mask } from 'vue-the-mask'


import { ref, watch } from 'vue'

export default {
  inheritAttrs: false,
  components: { Datepicker },
  directives: { mask },

  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: String,
    label: String,
    modelValue: String,
  },

  emits: ['update:modelValue'],

  setup( props, ctx ) {
    const datetimeValue = ref( props.modelValue?.replace( /(\d{4})\-(\d{2})\-(\d{2})/, '$3-$2-$1' ) )
    const error = ref(null)

    watch( () => props.error, () => error.value = props.error )

    watch( datetimeValue, () => {
      if ( datetimeValue.value.length == 16 ) {
        const formatedDate = datetimeValue.value.replace( /(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1' )
        error.value = null

        ctx.emit( 'update:modelValue', formatedDate )
      }
    })

    return { datetimeValue, error }
  }
}
</script>
